import React, { useState, useRef, useContext, useEffect } from 'react';
import axios from 'axios';
import '../../../assests/css/admin/AdmincmsManagement/AdmincmsHome.css';
import { AppContext } from '../../../context/Appcontext';
import { FaTrashAlt } from 'react-icons/fa';

const HeroCarouselManager = () => {
  const { baseUrl, baseUrlForFiles } = useContext(AppContext);

  const [carouselImages, setCarouselImages] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [image, setImage] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [title, setTitle] = useState('');
  const [carouselId, setCarouselId] = useState(null);

  const imageInputRef = useRef(null);

  // ================= VIEW ALL =================
  const viewAllCarousel = () => {
    axios.get(`${baseUrl}/admin/carousel/viewAll`)
      .then((response) => {
        setCarouselImages(response.data.posts);
      }).catch((error) => {
        console.log(error);
      });
  };

  // ================= ADD =================
  const addCarousel = () => {
    const formData = new FormData();
    formData.append("title", title);

    if (image) {
      formData.append("image", image);
    }

    setUploading(true);

    axios.post(`${baseUrl}/admin/carousel/add`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    }).then((response) => {
      console.log(response.data);
      setTitle('');
      setImage("");
      setImagePreview(null);
      viewAllCarousel();
    }).catch((error) => {
      console.log(error);
    })
  };

  // ================= DELETE =================
  const deleteCarousel = (idToDelete) => {
    console.log("*************");
    console.log(idToDelete);
    console.log("*************");
    const formData = new FormData();
    formData.append("id", idToDelete);

    axios.post(`${baseUrl}/admin/carousel/delete`, formData, {
      headers: { "Content-Type": "multipart/form-data" }
    }).then((response) => {
      console.log(response.data);
      viewAllCarousel();
    }).catch((error) => { console.log(error) })
  }

  // ================= RESET =================
  const resetForm = () => {
    setTitle('');
    setImage(null);
    setImagePreview(null);
    setCarouselId(null);
    setShowForm(false);
  };

  // ================= IMAGE HANDLER =================
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImage(file);
    setImagePreview(URL.createObjectURL(file));
  };

  useEffect(() => {
    viewAllCarousel();
  }, []);

  return (

    <div className="ab">
      <div className="ab__container">

        {/* HEADER */}
        <header className="ab__header">
          <div className="ab__header-left">
            <h1 className="ab__header-title">Hero Carousel CMS</h1>
            <p className="ab__header-sub">Manage homepage slider images</p>
          </div>

          <button
            className="ab__btn-new"
            onClick={() => setShowForm(!showForm)}
          >
            {showForm ? 'Cancel' : 'New Image'}
          </button>
        </header>

        {/* FORM */}
        {showForm && (
          <section className="ab__form-section">
            <h2 className="ab__section-title">Add Carousel Image</h2>

            <div className="ab__form-grid">

              <div className="ab__form-group ab__form-group--image">
                <label className="ab__form-label">Image</label>

                <input
                  type="file"
                  ref={imageInputRef}
                  style={{ display: "none" }}
                  onChange={handleImageChange}
                />

                <div
                  className="ab__image-uploader"
                  onClick={() => imageInputRef.current.click()}
                >
                  {imagePreview ? (
                    <img
                      src={imagePreview}
                      alt="preview"
                      className="ab__image-preview"
                    />
                  ) : (
                    <div className="ab__image-placeholder">
                      Click to upload
                    </div>
                  )}
                </div>
              </div>

              <div className="ab__form-fields">
                <div className="ab__form-group">
                  <label className="ab__form-label">Title</label>
                  <input
                    type="text"
                    className="ab__form-input"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    placeholder="Enter title"
                  />
                </div>
              </div>

            </div>

            <div className="ab__form-footer">
              <button
                className="ab__btn-submit"
                onClick={addCarousel}
              >
                Save
              </button>
            </div>
          </section>
        )}

        {/* TABLE */}
        <section className="ab__table-section">

          <div className="ab__table-header">
            <h2 className="ab__section-title">Carousel Images</h2>
            <span>{carouselImages.length} items</span>
          </div>

          <div className="ab__table-wrap">

            {carouselImages.length === 0 ? (
              <div className="ab__empty">
                No images found
              </div>
            ) : (
              <table className="ab__table">

                <thead>
                  <tr>
                    <th>#</th>
                    <th>Image</th>
                    <th>Title</th>
                    <th>Action</th>
                  </tr>
                </thead>

                <tbody>
                  {carouselImages.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>

                      <td>
                        <img
                          src={`${baseUrlForFiles}/${item.image}`}
                          alt={item.title}
                          className="ab__row-img"
                        />
                      </td>

                      <td>{item.title}</td>

                      <td>
                        <button
                          className="ab__action-btn ab__action-btn--delete"
                          onClick={() => deleteCarousel(item.id)}
                        >
                          <FaTrashAlt />
                          <span> Delete</span>
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>

              </table>
            )}

          </div>
        </section>

      </div>
    </div>

  );
};

export default HeroCarouselManager;